// App Imports
import params from '../../../setup/config/params'
import {IMAGE_SOURCE_PATH } from '../../../setup/config/env'
import List from '../List'
import CreateOrUpdate from '../CreateOrUpdate/index'
import CreateOrUpdateKnowledge from '../CreateOrUpdateKnowledge/index'
import botSettings from '../botSettings'
import { defaultImage } from '../../common/Sidebar';


// Image
export function getImageSource(image = defaultImage) {
  return `${ IMAGE_SOURCE_PATH }${ image }`
}

// Pages routes
const routes = {
  intentsList: {
    path: '/intents',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "intentManager",
    action: "canView",
  },
  knowledgeCreate: {
    path: '/knowledge/create',
    component: CreateOrUpdateKnowledge,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "intentManager",
    action: "canCreate",
  },
  intentCreate: {
    path: '/intent/create',
    component: CreateOrUpdate,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "intentManager",
    action: "canCreate",
  },
  intentEdit: {
    path: (intentId = ':intentId') => (`/intent/edit/${ intentId }`),
    component: CreateOrUpdate,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "intentManager",
    action: "canEdit",
  },
  botSettings: {
    path: '/bot/settings',
    component: botSettings,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "intentManager",
    action: "canView",
  },
  
}
export default routes;